import { createContext } from 'react';
import { Toast, toast } from 'react-toastify';

export const ToastContext = createContext<Toast>(toast);

export default ToastContext;